import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

interface GlassCardProps extends HTMLAttributes<HTMLDivElement> {
  /** Enables hover lift + glow */
  interactive?: boolean;
  /** Padding preset */
  padding?: "none" | "sm" | "md" | "lg";
}

const padMap = {
  none: "",
  sm: "p-4",
  md: "p-6",
  lg: "p-8",
} as const;

/**
 * Frosted glass surface used for cards, panels, dialogs.
 * Backed by --color-bg-card token + backdrop-filter.
 */
export const GlassCard = forwardRef<HTMLDivElement, GlassCardProps>(
  ({ className, interactive, padding = "md", children, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "glass rounded-[var(--radius-lg)]",
          padMap[padding],
          interactive && "glass-hover glass-hover-enabled cursor-pointer",
          className,
        )}
        {...rest}
      >
        {children}
      </div>
    );
  },
);
GlassCard.displayName = "GlassCard";
